export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  retrospectiveDay: state => state.retrospectiveDay,
  status: state => state.status,
  cleanRequest: state => state.cleanRequest,
  cleanVehicle: state => state.cleanVehicle,
  requests: state => state.requests,
  request: state => state.request,
  vinSummary: state => state.vinSummary,
  newVehicle: state => state.newVehicle,
  years: state => state.years,
  makes: state => state.makes,
  models: state => state.models,
  submodels: state => state.submodels,
  engines: state => state.engines,
  transmissions: state => state.transmissions,
  drivetypes: state => state.drivetypes,
  scantypes: state => state.scantypes,
  requestCount: state => state.requestCount,
  statuslist: state => state.statuslist,
  requestHistory: state => state.requestHistory,
  decodeError: state => state.decodeError,
  totalUnreadChats: state => state.totalUnreadChats,
  requestUnreadReset: state => state.requestUnreadReset,
  requestUnreadCount: state => state.requestUnreadCount,
  noRequest: state => state.noRequest,
  hubData: state => state.hubData,
  stateDefaults: state => state.stateDefaults,
  stateAssemblyOptions: state => state.stateAssemblyOptions,
  stateSrsOptions: state => state.stateSrsOptions,
  stateLightOptions: state => state.stateLightOptions,
  stateKeyEngineOptions: state => state.stateKeyEngineOptions,
  stateDamageLevelOptions: state => state.stateDamageLevelOptions,
  stateDamagePositionOptions: state => state.stateDamagePositionOptions,
  mobileHandoff: state => state.mobileHandoff,
  tools: state => state.tools,
  devices: state => state.devices,
  shopDevice: state => state.shopDevice,
  cleanGaugeOptions: state => state.cleanGaugeOptions,
  calibrateConfiguration: state => state.calibrateConfiguration,
  syncColumns: state => state.syncColumns
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/getters.js